import { FC } from 'react';
import { Chip } from '@mui/material';
import { observer } from 'mobx-react-lite';

import { DocumentListItem } from '@components/DocumentListItem';
import { Trans } from '@libs/i18n';
import { DomainStandardDocumentDetail } from '@libs/types';
import { WarningCircleIcon } from '@phosphor-icons/react';

interface MissingStandardDocumentItemProps {
  standardDocument: DomainStandardDocumentDetail;
}

export const MissingStandardDocumentItem: FC<MissingStandardDocumentItemProps> = observer(
  ({ standardDocument }) => (
    <DocumentListItem
      tone="warning"
      icon={WarningCircleIcon}
      filledIcon
      title={standardDocument.name}
      code={standardDocument.key}
      trailing={
        <Chip
          label={<Trans i18nKey="assessments.summary.missingBadge" />}
          size="small"
          sx={{ backgroundColor: 'warning.light', fontWeight: 600, flexShrink: 0 }}
        />
      }
    />
  ),
);
